<template>
  <div class="c-admin-model">
    <div
      class="c-admin-model__item o-grid o-grid--gutter-normal o-grid--align-items-center o-grid--no-overflow"
    >
      <div class="o-grid__group">
        <div
          class="c-admin-model__item c-admin-model__item--name o-grid__item o-grid__item--6"
        >
          <div :title="model.name" class="c-admin-model__item-text">
            {{ model.name }}
          </div>
        </div>
        <div
          class="c-admin-model__item c-admin-model__item--selectable o-grid__item o-grid__item--3"
        >
          {{
            model.isSelectable
              ? translationsCustom.selectableForEndUsers
              : translationsCustom.notSelectableForEndUsers
          }}
        </div>
        <div class="o-grid__item">
          <div class="o-grid o-grid--gutter-tiny">
            <div class="o-grid__group">
              <div class="o-grid__item"></div>
              <div class="o-grid__item o-grid__item--grow-0"></div>
              <div class="o-grid__item o-grid__item--grow-0">
                <button
                  @click.stop="showModelEdit(model)"
                  class="o-button o-button--action o-button--round o-button--light o-button--shadow"
                >
                  <svg
                    class="o-svg-icon o-button__icon"
                    viewBox="0 0 64 64"
                    type="image/svg+xml"
                  >
                    <use
                      xlink:href="spritemap.svg#sprite-edit"
                      x="0"
                      y="0"
                    ></use>
                  </svg>
                </button>
              </div>
              <div class="o-grid__item o-grid__item--grow-0">
                <button
                  :disabled="model.isInUse"
                  :title="
                    model.isInUse
                      ? 'Model is in use and cannot be deleted'
                      : 'Delete model'
                  "
                  @click.stop="showModelDelete(model)"
                  class="o-button o-button--action o-button--round o-button--light o-button--shadow"
                >
                  <svg
                    class="o-svg-icon o-button__icon"
                    viewBox="0 0 64 64"
                    type="image/svg+xml"
                  >
                    <use
                      xlink:href="spritemap.svg#sprite-delete"
                      x="0"
                      y="0"
                    ></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  props: {
    model: { type: Object, required: true }
  },
  computed: {
    ...mapState("manufacturers", {
      translationsManufacturersTable: "manufacturersTable",
      translationsCustom: "custom"
    }),
    ...mapState("translations", {
      translationsManufacturersTable: "manufacturersTable",
      translationsCustom: "custom"
    })
  },
  methods: {
    ...mapMutations("manufacturers", ["setEditModel", "setDeleteModel"]),
    showModelEdit(model) {
      this.setEditModel(model);
    },
    showModelDelete(model) {
      this.setDeleteModel(model);
    }
  }
};
</script>

<style lang="scss">
.c-admin-model {
  background-color: $s-cp-neutral-white;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 3px;

  &__item {
    padding: 0 10px;
    min-height: 46px;
  }

  &__item-text {
    margin-left: 30px;
  }
}
</style>
